import { useContext } from "react";
import { AppContext } from "../App";
import { Icon } from "../components/Icon";
import { t } from "../i18n";

export const PopupError = (props) => {
	const { popUpError, closePopUpError } = useContext(AppContext);

	return (
		<div
			className={
				"popup_error kensei_02" + (popUpError ? " isActive" : "")
			}
		>
			<div className="popup_error_content">
				<button
					onPointerDown={closePopUpError}
					className="popup_error_close"
				>
					<Icon name="close" className="popup_error_icon" />
				</button>
				<div className="popup_error_body">
					<div className="popup_error_header">
						<Icon name="error" className="popup_error_img" />
						<h2>
							{t(
								"Ups! parece que te faltan datos por rellenar.."
							)}
						</h2>
						<p>
							{t(
								"Completa todos los datos para darte una solución más eficiente y precisa."
							)}
						</p>
					</div>
					<button
						className="nav_next kensei_03"
						onPointerDown={closePopUpError}
					>
						<p className="footer_p">{t("Entendido")}</p>
					</button>
				</div>
			</div>
		</div>
	);
};
